import { useCallback } from 'react';
import cls from 'classnames';
import bottomLogo from '@/assets/images/bottom_logo.png';
import styles from './index.module.scss';
export default () => {
  const gotoDetail = useCallback((path: string) => {
    window.open(path);
  }, []);
  return (
    <div className={styles['footer']}>
      <div className={styles['footer-inner']}>
        <div className={styles['logo-waper']}>
          <img src={bottomLogo} />
        </div>
        <div className={styles['line']}></div>
        <div className={cls(styles['link-content'], 'flex')}>
          <a href={'javascript:;'} className={cls(styles['link-us'], 'flex1')}>
            联系我们
          </a>
          <div className={styles['right-link']}>
            <a onClick={() => gotoDetail('/#/Privacy')}>使用条款</a>|
            <a onClick={() => gotoDetail('/#/UseTerm')}>隐私条款</a>|
            <a onClick={() => gotoDetail('/#/cookie')}>Cookie声明</a>
          </div>
        </div>
        <div className={styles['info-item']}>登赫（上海）生命科学有限公司</div>
        <div className={styles['info-item']}>地址：上海市长宁区福泉北路518号1座5层 邮编：200335</div>
        <div className={cls(styles['footer-link'], 'flex')}>
          {/* <img src={guohui} className={styles['guohui-logo']} /> */}
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
            沪ICP备2021031230号{' '}
          </a>
        </div>
      </div>
    </div>
  );
};
